/**
 * Consume the backend's shared Guesty bookability decision. The status
 * fallback keeps older cached payloads safe during rolling deployments.
 */
export function isListingCalendarRowBookable(row) {
    if (!row || typeof row !== 'object') return false;
    if (typeof row.bookable === 'boolean') return row.bookable;

    return row.status === 'available';
}
